import { css } from 'linaria';

export const root = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const message = css`
  display: flex;
  align-items: center;
`;

export const icon = css`
  margin-right: var(--space-100);
`;
